import { CoreLocationCitiesFilter } from './CoreLocationCitiesFilter';
import { CoreLocationClusterFilter } from './CoreLocationClusterFilter';
import { CoreLocationCountBadge } from './CoreLocationCountBadge';
import { CoreLocationCountryFilter } from './CoreLocationCountryFilter';
import { CoreLocationFilter } from './CoreLocationFilter';
import { CoreLocationGroupFilter } from './CoreLocationGroupFilter';
import { CoreLocationRegionFilter } from './CoreLocationRegionFilter';
import { CoreLocationTerritoryFilter } from './CoreLocationTerritoryFilter';
import { CoreLocationTypeFilter } from './CoreLocationTypeFilter';

export const CoreLocationGeneralFilters = {
  Location: CoreLocationFilter,
  Cities: CoreLocationCitiesFilter,
  LocationType: CoreLocationTypeFilter,
  Territory: CoreLocationTerritoryFilter,
  Region: CoreLocationRegionFilter,
  Country: CoreLocationCountryFilter,
  City: CoreLocationCitiesFilter,
  LocationCluster: CoreLocationClusterFilter,
  LocationGroup: CoreLocationGroupFilter,
  CountBadge: CoreLocationCountBadge,
};
